import { SCAYLE_AUTH_ID, SCAYLE_AUTH_SECRET } from 'src/envVariables';

export const getAuthBasicHeader = (
  authId = SCAYLE_AUTH_ID,
  authSecret = SCAYLE_AUTH_SECRET,
) => {
  const base64Encode = (data: string) => Buffer.from(data).toString('base64');

  const authToken = `Basic ${base64Encode(`${authId}:${authSecret}`)}`;

  return { Authorization: authToken };
};
